import { MapOptions } from '@2gis/mapgl/types';
import { Dictionary } from 'lodash';
import { SITE_COUNTRY_CODE } from 'Douleutaras/constants/localization';

// 2GIS provides much better coverage than Google Maps for Cyprus, so the location
// picker swaps Google out for 2GIS there. Keys are supplied via the environment,
// mirroring the GOOGLE_API_KEY wiring (dotenv-webpack, systemvars: true).
export const TWO_GIS_GEOCODER_KEY = process.env.TWO_GIS_GEOCODER_KEY || '';
export const TWO_GIS_MAPGL_KEY = process.env.TWO_GIS_MAPGL_KEY || '';

// Fields requested from the 2GIS catalog API so a result carries coordinates and a
// full, human-readable address.
const RESPONSE_FIELDS = 'items.point,items.full_address_name,items.address,items.adm_div';
// 2GIS region id for Cyprus — scopes both autocomplete and geocoding to the island.
const CYPRUS_REGION_ID = '173';

export const twoGisAutocompleteOptions: Dictionary<string> = {
  key: TWO_GIS_GEOCODER_KEY,
  region_id: CYPRUS_REGION_ID,
  fields: RESPONSE_FIELDS
};

export const twoGisGeocoderOptions: Dictionary<string> = {
  key: TWO_GIS_GEOCODER_KEY,
  region_id: CYPRUS_REGION_ID,
  fields: RESPONSE_FIELDS,
  locale: 'en_CY'
};

export const twoGisMapOptions: MapOptions = {
  key: TWO_GIS_MAPGL_KEY,
  zoom: 14,
  zoomControl: false
};

// Default Cyprus map center in 2GIS `[longitude, latitude]` order (mirrors
// COUNTRY_CONFIG.MAP_CENTER[CY] = { lat: 35.095192, lng: 33.20343 }).
export const CYPRUS_MAP_CENTER: [number, number] = [33.20343, 35.095192];

// Whether the current country should use 2GIS instead of Google for location picking.
export const isTwoGisEnabled = (countryCode: SITE_COUNTRY_CODE): boolean =>
  countryCode === SITE_COUNTRY_CODE.CY && (TWO_GIS_GEOCODER_KEY !== '' && TWO_GIS_MAPGL_KEY !== '');
